import { useEffect, useState } from 'react';
import { apiClient } from './apiClient';
import type { TenderStatus } from '../types';

/**
 * Tender counts for the sidebar badge. Cheap on purpose: once on mount, then
 * every ten minutes, and silent on failure — a badge must never break the nav.
 */
export function useTenderStatus(enabled: boolean): TenderStatus | null {
  const [status, setStatus] = useState<TenderStatus | null>(null);

  useEffect(() => {
    if (!enabled) return;
    let alive = true;
    const load = () =>
      apiClient
        .get<TenderStatus>('/tenders/status')
        .then((s) => { if (alive) setStatus(s); })
        .catch(() => undefined);
    load();
    const timer = window.setInterval(load, 10 * 60 * 1000);
    return () => { alive = false; window.clearInterval(timer); };
  }, [enabled]);

  return status;
}
